import { getDateArgsFromIso8601String } from './getDateArgsFromIso8601String'
import { isIso8601DateString } from './isIso8601DateString'

/*
  new Date() interprets the date string by identifying the type of date is being used.
  Edge cases are left up to the browsers. ISO-8601 is the standard but it factors timezone
  in certain situations.
  
  '2020-01-01' is an ISO-8601 formatted date. It interprets the string in UTC time, 
  and it calculates timezone offset.
  So, a new Date('2020-01-01') will be figured into the local timezone. If the local timezone
  is negative to utc (Chicago, UTC -6), then the date will be translated to 2019-12-31.

  Birthday's don't change depending on timezone. 
  So if someone is born on 01-01-2005, it should not change depending on what timezone you read it in.

  An international date format (yyyy-mm-dd) with slashes instead of dashes
  will fix in some browsers but not all browsers.

  So, the stablest way to interpret the date is to not use the new Date() string parsing,
  and instead pass the values in directly.
*/

export const getBirthDate = (internationalDateString: string): Date => {
  const isInternationalDateFormat = isIso8601DateString(internationalDateString)
  const dateParsedFromString = new Date(internationalDateString)

  if (!isInternationalDateFormat) {
    return dateParsedFromString
  }

  try {
    const [year, monthIndex, day] = getDateArgsFromIso8601String(
      internationalDateString
    )

    const birthDate = new Date(year, monthIndex, day)

    return birthDate
  } catch (_) {
    return dateParsedFromString
  }
}
